import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrestacaoDeContas from './prestacaoDeContas';

export default (
  <Route path="/homepage/prestacao-de-contas">
    <Switch>
      <Route exact path="/homepage/prestacao-de-contas" component={PrestacaoDeContas} />
    </Switch>
  </Route>
);
 